export default __webpack_public_path__ + "static/Mid-Market_Leader-2360600c05894cd42f39e2ad82cbf3eb.svg";